import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import SelectPicker, { SelectPickerField } from 'components/form/selectpicker'
import {
  applySpec,
  pipe,
  identity,
  defaultTo,
  cond,
  isEmpty,
  propEq,
  T,
  not
} from 'ramda'

const selector = formValueSelector('widget')

const mapKeysToOptions = obj =>
  Object.keys(obj).map((key, index) => (
    <option key={index} value={key}>
      {key}
    </option>
  ))

export const componentSelector = (options, platform) => {
  const RenderComp = ({ input, itemName }) => {
    const Component = options[input.value]
    return Component ? <Component name={itemName} platform={platform} /> : null
  }

  RenderComp.propTypes = {
    input: PropTypes.any,
    itemName: PropTypes.string
  }

  return RenderComp
}

const mosaicHasMedia = pipe(defaultTo([]), isEmpty, not)

export const createFieldArraySelect = ({
  platform,
  label,
  options,
  isFilterList
}) => {
  const optionElements = mapKeysToOptions(options)
  const selectedComponent = componentSelector(options, platform)

  const FieldItem = (item, index, fields, mediaId) => {
    const itemData = fields.get(index)

    const isDisabled = cond([
      [propEq('type', 'Add to mosaic'), () => mosaicHasMedia(mediaId)],
      [T, () => false]
    ])(itemData)

    return (
      <div className='br-set-item row' key={index}>
        <div className='col-xs-9 col-sm-10 col-md-3'>
          <Field
            id={`type-select-${index}`}
            name={`${item}.type`}
            component={SelectPickerField}
            disabled
            format={defaultTo('')}
            className='form-control'
          >
            {optionElements}
          </Field>
        </div>
        <div className='br-delete-btn col-xs-3 col-sm-2 col-md-1 col-md-push-8'>
          {isFilterList ? null : (
            <button
              className='btn btn-sm dark'
              onClick={() => fields.remove(index)}
              type='button'
              disabled={isDisabled}
            >
              <i className='fa fa-close' />
            </button>
          )}
        </div>

        <div className='br-item-config col-xs-12 col-sm-12 col-md-8 col-md-pull-1'>
          <Field
            name={`${item}.type`}
            component={selectedComponent}
            itemName={item}
            className='form-control'
          />
        </div>
      </div>
    )
  }

  const FieldItemsField = ({ fields, meta: { error }, mediaId }) => (
    <div className='col-sm-12 br-set-group'>
      {fields.map((item, index, fields) =>
        FieldItem(item, index, fields, mediaId)
      )}
      {isFilterList && fields.length !== 0 ? null : (
        <div className='br-select-item row'>
          <div className='col-sm-4 col-md-3'>
            <SelectPicker
              title={label}
              value=''
              className='selectpicker form-control'
              onChange={pipe(
                applySpec({ type: identity }),
                fields.push.bind(fields)
              )}
            >
              {optionElements}
            </SelectPicker>
          </div>
          {error && (
            <div className='col-sm-8 col-md-9'>
              <div className='has-error-text selectpicker-error-right'>
                {error}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )

  FieldItemsField.propTypes = {
    fields: PropTypes.any,
    meta: PropTypes.object,
    mediaId: PropTypes.any
  }

  const FieldItems = connect(state => ({
    mediaId: selector(state, 'mosaic.mediaId')
  }))(FieldItemsField)

  return {
    FieldItem,
    FieldItems,
    FieldItemsField
  }
}

export default createFieldArraySelect



// WEBPACK FOOTER //
// ./src/pages/widgets/form/field-array-select/index.js